import { baseApi } from "./base.api";

export const pagesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // ─── Legacy page endpoints (blog, contact, etc.) ────────────────────────
    fetchBlogPage: build.query({
      query: (params = {}) => ({ url: "/frontend/blog", method: "GET", params }),
      providesTags: [{ type: "Page", id: "blog" }],
    }),
    fetchBlogDetailPage: build.query({
      query: (slug) => ({ url: `/frontend/blog/${slug}`, method: "GET" }),
      providesTags: (_r, _e, slug) => [{ type: "Page", id: `blog-${slug}` }],
    }),
    fetchContactPage: build.query({
      query: () => ({ url: "/frontend/contact", method: "GET" }),
      providesTags: [{ type: "Page", id: "contact" }],
    }),
    fetchBrandSinglePage: build.query({
      query: (slug) => ({ url: `/frontend/brands/${slug}`, method: "GET" }),
      providesTags: (_r, _e, slug) => [{ type: "Page", id: `brand-${slug}` }],
    }),
    fetchSearch: build.query({
      query: ({ q, type }) => ({ url: "/frontend/search", method: "GET", params: { q, ...(type ? { type } : {}) } }),
    }),

    // ─── Frontend APIs ───────────────────────────────────────────────────────
    fetchHeaderContent: build.query({
      query: () => ({ url: "/frontend/header-content", method: "GET" }),
      providesTags: [{ type: "Page", id: "header-content" }],
    }),
    fetchSliders: build.query({
      query: () => ({ url: "/frontend/sliders", method: "GET" }),
      providesTags: [{ type: "Page", id: "sliders" }],
    }),
    fetchHomeFeaturedCategories: build.query({
      query: () => ({ url: "/frontend/home/featured/categories", method: "GET" }),
      providesTags: [{ type: "Page", id: "home-featured-categories" }],
    }),
    fetchHomeFeaturedProducts: build.query({
      query: () => ({ url: "/frontend/home/featured/products", method: "GET" }),
      providesTags: [{ type: "Page", id: "home-featured-products" }],
    }),
    fetchHomeNewArrivalProducts: build.query({
      query: () => ({ url: "/frontend/home/new-arrival/products", method: "GET" }),
      providesTags: [{ type: "Page", id: "home-new-arrival-products" }],
    }),
    fetchHomeFeaturedBlogs: build.query({
      query: () => ({ url: "/frontend/home/featured/blogs", method: "GET" }),
      providesTags: [{ type: "Page", id: "home-featured-blogs" }],
    }),
    fetchHomeFeaturedBanner: build.query({
      query: () => ({ url: "/frontend/home/featured/banner", method: "GET" }),
      providesTags: [{ type: "Page", id: "home-featured-banner" }],
    }),
    fetchAllProducts: build.query({
      query: (params = {}) => ({ url: "/frontend/products/all", method: "GET", params }),
      providesTags: [{ type: "Page", id: "all-products" }],
    }),
    fetchProductBySlug: build.query({
      query: (slug) => ({ url: `/frontend/product/${slug}`, method: "GET" }),
      providesTags: (_r, _e, slug) => [{ type: "Page", id: `product-${slug}` }],
    }),
    fetchRandomProducts: build.query({
      query: (slug) => ({ url: `/frontend/products/random/${slug}`, method: "GET" }),
      providesTags: (_r, _e, slug) => [{ type: "Page", id: `random-products-${slug}` }],
    }),
    fetchFrontendCategories: build.query({
      query: () => ({ url: "/frontend/categories", method: "GET" }),
      providesTags: [{ type: "Page", id: "frontend-categories" }],
    }),
    fetchFrontendSubCategories: build.query({
      query: (categorySlug) => ({
        url: "/frontend/sub-categories",
        method: "GET",
        params: categorySlug ? { category_slug: categorySlug } : {},
      }),
      providesTags: (_r, _e, categorySlug) => [{ type: "Page", id: `frontend-sub-categories-${categorySlug ?? "all"}` }],
    }),
    fetchFrontendBrands: build.query({
      query: () => ({ url: "/frontend/brands", method: "GET" }),
      providesTags: [{ type: "Page", id: "frontend-brands" }],
    }),
    fetchFAQsData: build.query({
      query: () => ({ url: "/frontend/faqs/data", method: "GET" }),
      providesTags: [{ type: "Page", id: "faqs" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  // Legacy
  useFetchBrandSinglePageQuery,
  useFetchBlogPageQuery,
  useFetchBlogDetailPageQuery,
  useFetchContactPageQuery,
  useLazyFetchSearchQuery,
  // Frontend APIs
  useFetchHeaderContentQuery,
  useFetchSlidersQuery,
  useFetchHomeFeaturedCategoriesQuery,
  useFetchHomeFeaturedProductsQuery,
  useFetchHomeNewArrivalProductsQuery,
  useFetchHomeFeaturedBlogsQuery,
  useFetchHomeFeaturedBannerQuery,
  useFetchAllProductsQuery,
  useFetchProductBySlugQuery,
  useFetchRandomProductsQuery,
  useFetchFrontendCategoriesQuery,
  useFetchFrontendSubCategoriesQuery,
  useFetchFrontendBrandsQuery,
  useFetchFAQsDataQuery,
} = pagesApi;
